export default __webpack_public_path__ + "static/media/teltonika-FMB630.a5089cf4.png";